module.exports = __webpack_public_path__ + "static/img/hhywelcome1.99a8143.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hhypc/hhywelcome1.png
// module id = PbhF
// module chunks = 230